<template>
  <div class="collapse-item">
    <div :class="{ reverse }" class="collapse-item__heading" @click="toggle">
      <div :class="{ opened }" class="arrow sf-mr-s"/>
      <slot name="title"/>
    </div>
    <sf-slide-toggle v-model="opened" :class="{ opened }">
      <div class="inside sf-pt-s sf-pb-xs">
        <slot/>
      </div>
    </sf-slide-toggle>
  </div>
</template>

<script>
export default {
  props: {
    el: { type: String, default: '' },
  },
  data: () => ({
    opened: false,
  }),
  computed: {
    reverse() {
      return this.$parent.isRight;
    },
    accordion() {
      return this.$parent.accordion;
    },
  },
  watch: {
    $route() {
      this.opened = false;
    },
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
      const offsetHeight = this.$parent.closeAllItems(this.$el);
      this.$emit('click', { el: this.el, offsetHeight });
    },
  },
};
</script>
